import axios from "axios";

const API_BASE = String(process.env.REACT_APP_NOT_SECRET_CODE || "").replace(
  /\/$/,
  "",
);
const API_V1_BASE = /\/api\/v1$/i.test(API_BASE)
  ? API_BASE
  : `${API_BASE}/api/v1`;

const defaultHeaders = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: `Bearer ${token}`,
});

const compactParams = (params) =>
  Object.keys(params || {}).reduce((result, key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value;
    }
    return result;
  }, {});

export const fetchDoctorConsultationPayments = (
  token,
  filters,
  cancelToken,
) =>
  axios.get(`${API_V1_BASE}/doctor-consultation-payments`, {
    cancelToken,
    headers: defaultHeaders(token),
    params: compactParams(filters),
  });

export const exportDoctorConsultationPayments = (token, filters) =>
  axios.get(`${API_V1_BASE}/doctor-consultation-payments/export`, {
    headers: defaultHeaders(token),
    params: compactParams(filters),
    responseType: "blob",
  });

export const downloadDoctorPeriodPayslip = (token, doctorId, payload) =>
  axios.post(
    `${API_V1_BASE}/doctor-consultation-payments/doctors/${doctorId}/payslip`,
    payload,
    { headers: defaultHeaders(token), responseType: "blob" },
  );

export const updateConsultationPaymentStatus = (
  token,
  paymentId,
  payload,
) =>
  axios.put(
    `${API_V1_BASE}/doctor-consultation-payments/${paymentId}/status`,
    payload,
    { headers: defaultHeaders(token) },
  );

export const markConsultationPaymentsPaid = (token, paymentIds) =>
  axios.post(
    `${API_V1_BASE}/doctor-consultation-payments/mark-paid`,
    { payment_ids: paymentIds },
    { headers: defaultHeaders(token) },
  );

export const isCancelledRequest = (error) => axios.isCancel(error);

export const createRequestCancelSource = () => axios.CancelToken.source();
